export function getVoiceApiBaseUrl() {
  const configured =
    process.env.REACT_APP_VOICE_API_URL ??
    process.env.NEXT_PUBLIC_VOICE_API_URL ??
    process.env.VITE_VOICE_API_URL ??
    process.env.REACT_APP_VOICE_API;

  if (configured) {
    return configured.replace(/\/+$/, "");
  }

  if (typeof window !== "undefined") {
    if (window.location.hostname === "localhost") {
      return "http://localhost:3003";
    }
  }

  return "https://voice.harper.new";
}

export function buildVoiceUrl(path: string) {
  const base = getVoiceApiBaseUrl();
  const normalizedPath = path.replace(/^\/+/, "");
  return `${base}/${normalizedPath}`;
}

function toWsBase(base: string) {
  if (base.startsWith("https://")) {
    return `wss://${base.slice("https://".length)}`;
  }
  if (base.startsWith("http://")) {
    return `ws://${base.slice("http://".length)}`;
  }
  return base;
}

export function buildVoiceWsUrl(path: string) {
  const base = toWsBase(getVoiceApiBaseUrl()).replace(/\/+$/, "");
  const normalizedPath = path.replace(/^\/+/, "");
  return `${base}/${normalizedPath}`;
}
